<template>
<div class="roterContainer">
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component v-if="route.meta.keepAlive" :is="Component" :key="route.name"></component>
    </keep-alive>
      <component v-if="!route.meta.keepAlive" :is="Component" :key="route.name"></component>
  </router-view>
   <img class="back" src="@/assets/images/返回.png" width="60" height="60"
   v-show="closeDisplay" @click="back" :style="{right: backButtonRight}" />
  </div>
</template>
<script setup>
import {
  reactive, toRefs, watch, onMounted, ref,
} from 'vue';
import { useRouter, onBeforeRouteUpdate, useRoute } from 'vue-router';

const closeDisplay = ref(false);
let isFirstPage = false;
const router = useRouter();
const route = useRoute();
const backButtonRight = ref(0);
watch(
  () => route.path,
  (val) => {
    if (val === '/') {
      closeDisplay.value = false;
    } else {
      closeDisplay.value = true;
    }
  },
  {
    immediate: true,
  },
);

watch(
  () => router,
  (val) => {
    if (!router.options.history.state.back) {
      isFirstPage = true;
    } else {
      isFirstPage = false;
    }
  },
  {
    immediate: true,
    deep: true,
  },
);

const back = () => {
  if (isFirstPage) {
    router.push({ path: '/' });
  } else {
    router.back();
  }
};

onMounted(() => {
  const { clientWidth } = document.body;
  if (clientWidth > 750) {
    backButtonRight.value = `${(clientWidth - 750) / 2}px`;
  }
});
</script>
<style lang="scss" scoped>
.roterContainer {
  position: relative;
}
.back {
  position: fixed;
  right: 0px;
  bottom: 100px;
}
</style>
